// extracted by mini-css-extract-plugin
export default {"trans":"index_trans_nLEm-","item":"index_item_ehDln clearfix","pic":"index_pic_2jTrH","txt":"index_txt_cptrG","list11":"index_list11_0AOqC"};